import Tracker from 'fk-ui-common/tracking/index'
import type { FDPEvent, NavigationContext } from 'fk-ui-common/tracking/types'
import TRACKING_EVENTS from './eventNames'
import type BaseEvent from './BaseEvent'
import { TENANT } from 'constants.app'
import { getUserLoggedInStatus } from 'helpers/utils'

const tracker = Tracker.getInstance(TENANT)
export const trackRCBPEvent = (eventData: BaseEvent, flushEvents = false): void => {
  const eventName = eventData.getEventName()
  const modifiedNavigationContext: NavigationContext = { mpid: 'RCBP' }
  const { nc, ...data } = eventData.toPlainObject()

  const updatedData = {
    rlt: getUserLoggedInStatus(),
    ...data,
  }

  switch (eventName) {
    case TRACKING_EVENTS.PAGE_VIEW:
    case TRACKING_EVENTS.RCBP_SEARCH_PAGE_LOAD:
    case TRACKING_EVENTS.RCBP_PAYMENTS_LOAD:
    case TRACKING_EVENTS.RCBP_SELECT_PLAN_LOAD:
    case TRACKING_EVENTS.RCBP_BILL_DETAILS:
      Object.assign(modifiedNavigationContext, nc)
      break
  }
  const pn = modifiedNavigationContext?.pn
  if (pn !== null && pn !== undefined) {
    // eslint-disable-next-line
    tracker.updateNavigationContext(modifiedNavigationContext)
  }
  // todo: correctly type this
  tracker.trackEvent(updatedData as unknown as FDPEvent, flushEvents)
}
